<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">
      <h3 class="page-header">Edit User Permissions</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-lg-6">
      <ng-container *ngIf="sourceUsers != null">
        <span>{{this.isCloneUser.value?'Source User:':'User:'}}</span> &nbsp;
        <aims-lookup
          name="sourceUserLookup"
          [gridText]="'Select a User'"
          [values]="sourceUsers | async"
          [idPropertyName]="'userId'"
          [displayPropertyName]="'userName'"
          [columnsInGrid]="userLookupColumns"
          [altDisplay]="(sourceUser | async)?.userName"
          (valueChangeObj)="handleSourceUserLookupChange($event)"
        >
        </aims-lookup>
      </ng-container>
    </div>
  </div>
  <div class="row top20" *ngIf="this.canCloneUser && this.isCloneUser.value == false">
    <aims-common-button
      aria-label="Clone this User"
      (click)="handleOpenCloneUser()"
      [disabled]="!sourceUser">
      <mat-icon>content_copy</mat-icon>
      Clone
    </aims-common-button>
  </div>
  <div class="row top20" *ngIf="this.canCloneUser && this.isCloneUser.value == true">
    <div class="col-xs-12 col-lg-6">
      <b>Destination User:</b> &nbsp;
      <aims-lookup
        name="destinationUserLookup"
        [gridText]="'Select a Destination User'"
        [values]="destinationUsers | async"
        [idPropertyName]="'userId'"
        [displayPropertyName]="'userName'"
        [altDisplay]="(destinationUser | async)?.userName"
        (valueChangeObj)="handleDestinationUserLookupChange($event)"
        [columnsInGrid]="activeUserLookupColumns"
        required
        >
      </aims-lookup>
    </div>
  </div>
  <div class="flex-container end" *ngIf="this.isCloneUser.value == true">
    <aims-common-button
      aria-label="Cancel"
      (click)="handleCancelClone()">
        Cancel
    </aims-common-button>

    <aims-common-button
      aria-label="Clone User"
      (click)="handleCloneUser()"
      [disabled]="
        this.sourceUser?.value.userName == '' ||
        this.destinationUser?.value.userName == '' ||
        (this.cloneUserGroupsSelected.length == 0 &&
        this.cloneUserPermissionsSelected.length == 0)"
      *ngIf="this.canCreate">
        <mat-icon>content_copy</mat-icon>
        Clone User
    </aims-common-button>
  </div>
  <div class="row top10" *ngIf="this.isCloneUser.value == false">
    <div class="col-sm-12 col-lg-8">
      <aims-form [cols]="3">
        <aims-fc>
            <aims-numeric
              [numericType]="AIMS_NUMERIC_TYPES.CURRENCY"
              #aimsControl="ngModel"
              name="Purchase Authority"
              [(ngModel)]="arctecFunds"
              (blur)="handleBlurArctecFundsPurchaseAuth($event)">
            </aims-numeric>
        </aims-fc>
        <aims-fc>
            <aims-numeric
              [numericType]="AIMS_NUMERIC_TYPES.CURRENCY"
              #aimsControl="ngModel"
              name="O&amp;A Funds"
              [(ngModel)]="oaFunds"
              (blur)="handleBlurOAFundsPurchaseAuth($event)">
            </aims-numeric>
        </aims-fc>
        <aims-fc>
            <aims-numeric
              [numericType]="AIMS_NUMERIC_TYPES.CURRENCY"
              #aimsControl="ngModel"
              name="Gov Funds"
              [(ngModel)]="govtFunds"
              (blur)="handleBlurGovtFundsPurchaseAuth($event)">
            </aims-numeric>
        </aims-fc>
      </aims-form>
    </div>
  </div>

  <mat-tab-group selectedIndex="0" mat-align-tabs="start">
    <mat-tab label="Permissions">
      <div class="table-container">
        <!-- Permissions -->
        <form novalidate #permGrid="ngForm" *ngIf="(sourceUserPermissions|async) != null && this.isCloneUser.value == false">
        <div>
            <aims-common-table
              [dataSource]="sourceUserPermissionsDataSource"
              [header]="userPermissionsColumns"
              [permissions]="permissions"
              id="UserPermissions"
              (rowAdded)="handlePermissionsRowAdd($event)"
              (rowUpdated)="handlePermissionsRowUpdate($event)"
              (rowDeleted)="handlePermissionsRowDelete($event)"
              (rowCancelled)="handlePermissionsRowCancelled($event)"
              [addRowInitialObject]="defaultPermissionsAddRowInitialObject"
              [stickyHeader]="true"
              [pageSize]="10"
            >
              <!-- Component Name -->
              <aims-common-table-dynamic-row id="component.component">
                <ng-template viewMode let-element>
                  {{element.component?.component}}
                </ng-template>
                <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <aims-lookup
                      [ngClass]="{'ng-invalid': dynamicControl?.invalid}"
                      name="component.component"
                      [gridText]="'Select a Component'"
                      id="componentNameLookup"
                      [values]="components | async"
                      [idPropertyName]="'componentId'"
                      [displayPropertyName]="'component'"
                      [columnsInGrid]="componentNameLookupColumns"
                      [altDisplay]="dynamicControl?.value"
                      (valueChangeObj)="handleComponentLookupChange($event, element, dynamicControl)"
                    >
                    </aims-lookup>

                </ng-template>
              </aims-common-table-dynamic-row>

              <!--Create-->
              <aims-common-table-dynamic-row id="create">
                <ng-template viewMode let-element>
                  <div class="text-center">
                    <ng-container *ngIf="element.create">
                      <img src="{{imgSrc}}/check.png" style="width:20px" />
                    </ng-container>
                    <ng-container *ngIf="!element.create">
                      <img src="{{imgSrc}}/X.png" style="width:20px" />
                    </ng-container>
                  </div>
                </ng-template>
                <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                  <div class="fullWidth text-center">
                    <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                  </div>
                </ng-template>
              </aims-common-table-dynamic-row>
              <!-- Read -->
              <aims-common-table-dynamic-row id="read">
                <ng-template viewMode let-element>
                  <div class="fullWidth text-center">
                    <ng-container *ngIf="element.read">
                      <img src="{{imgSrc}}/check.png" style="width:20px" />
                    </ng-container>
                    <ng-container *ngIf="!element.read">
                      <img src="{{imgSrc}}/X.png" style="width:20px" />
                    </ng-container>
                  </div>
                </ng-template>
                <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                  <div class="fullWidth text-center">
                    <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                  </div>
                </ng-template>
              </aims-common-table-dynamic-row>

              <!-- Update -->
              <aims-common-table-dynamic-row id="update">
                <ng-template viewMode let-element>
                  <div class="fullWidth text-center">
                    <ng-container *ngIf="element.update">
                      <img src="{{imgSrc}}/check.png" style="width:20px" />
                    </ng-container>
                    <ng-container *ngIf="!element.update">
                      <img src="{{imgSrc}}/X.png" style="width:20px" />
                    </ng-container>
                  </div>
                </ng-template>
                <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                  <div class="fullWidth text-center">
                    <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                  </div>
                </ng-template>
              </aims-common-table-dynamic-row>

              <!-- Delete -->
              <aims-common-table-dynamic-row id="delete">
                <ng-template viewMode let-element>
                  <div class="fullWidth text-center">
                    <ng-container *ngIf="element.delete">
                      <img src="{{imgSrc}}/check.png" style="width:20px" />
                    </ng-container>
                    <ng-container *ngIf="!element.delete">
                      <img src="{{imgSrc}}/X.png" style="width:20px" />
                    </ng-container>
                  </div>
                </ng-template>
                <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                  <div class="fullWidth text-center">
                    <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                  </div>
                </ng-template>
              </aims-common-table-dynamic-row>
            </aims-common-table>
          </div>
        </form>
        <!-- Clone Permissions -->
        <form novalidate #permGrid="ngForm" *ngIf="(destinationUserPermissions|async) && this.isCloneUser.value == true">
        <div class="flex-container">
            <!-- Source User Permissions -->
            <div class="flex-column">
              <h4>Source User {{(this.sourceUser | async)?.userName}}</h4>
              <aims-common-table
                [dataSource]="sourceUserPermissionsDataSource"
                [header]="cloneSourceUserPermissionsColumns"
                [permissions]="clonePermissions"
                id="CloneSourceUserPermissions"
                (selectionClick)="handleCloneUserPermissionRowClick($event)"
                (selectionAllClick)="handleCloneUserPermissionRowClick($event)"
                [stickyHeader]="true"
                [pageSize]="10"
                [formOptions]="{ type: 'full' }"
              >
                <!-- Component Name -->
                <aims-common-table-dynamic-row id="component.component">
                  <ng-template viewMode let-element>
                    {{element.component?.component}}
                  </ng-template>
                  <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                      <aims-lookup
                        [ngClass]="{'ng-invalid': dynamicControl?.invalid}"
                        name="component.component"
                        [gridText]="'Select a Component'"
                        id="componentNameLookup"
                        [values]="components | async"
                        [idPropertyName]="'componentId'"
                        [displayPropertyName]="'component'"
                        [columnsInGrid]="componentNameLookupColumns"
                        [altDisplay]="dynamicControl?.value"
                        (valueChangeObj)="handleComponentLookupChange($event, element, dynamicControl)"
                      >
                      </aims-lookup>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!--Create-->
                <aims-common-table-dynamic-row id="create">
                  <ng-template viewMode let-element>
                    <div class="text-center">
                      <ng-container *ngIf="element.create">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.create">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                  <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <div class="fullWidth text-center">
                      <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>
                <!-- Read -->
                <aims-common-table-dynamic-row id="read">
                  <ng-template viewMode let-element>
                    <div class="fullWidth text-center">
                      <ng-container *ngIf="element.read">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.read">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                  <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <div class="fullWidth text-center">
                      <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!-- Update -->
                <aims-common-table-dynamic-row id="update">
                  <ng-template viewMode let-element>
                    <div class="fullWidth text-center">
                      <ng-container *ngIf="element.update">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.update">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                  <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <div class="fullWidth text-center">
                      <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <!-- Delete -->
                <aims-common-table-dynamic-row id="delete">
                  <ng-template viewMode let-element>
                    <div class="fullWidth text-center">
                      <ng-container *ngIf="element.delete">
                        <img src="{{imgSrc}}/check.png" style="width:20px" />
                      </ng-container>
                      <ng-container *ngIf="!element.delete">
                        <img src="{{imgSrc}}/X.png" style="width:20px" />
                      </ng-container>
                    </div>
                  </ng-template>
                  <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <div class="fullWidth text-center">
                      <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                    </div>
                  </ng-template>
                </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
            <!--Destination User-->
            <div class="flex-column">
              <h4>Destination User {{(this.destinationUser | async)?.userName}}</h4>
              <aims-common-table
                  [dataSource]="destinationUserPermissionsDataSource"
                  [header]="cloneDestinationUserPermissionsColumns"
                  [permissions]="clonePermissions"
                  id="CloneDestinationUserPermissions"
                  (selectionClick)="handleCloneUserPermissionRowClick($event)"
                  (selectionAllClick)="handleCloneUserPermissionRowClick($event)"
                  [stickyHeader]="true"
                  [pageSize]="10"
                >
                  <!-- Component Name -->
                  <aims-common-table-dynamic-row id="component.component">
                    <ng-template viewMode let-element>
                      {{element.component?.component}}
                    </ng-template>
                    <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                        <aims-lookup
                          [ngClass]="{'ng-invalid': dynamicControl?.invalid}"
                          name="component.component"
                          [gridText]="'Select a Component'"
                          id="componentNameLookup"
                          [values]="components | async"
                          [idPropertyName]="'componentId'"
                          [displayPropertyName]="'component'"
                          [columnsInGrid]="componentNameLookupColumns"
                          [altDisplay]="dynamicControl?.value"
                          (valueChangeObj)="handleComponentLookupChange($event, element, dynamicControl)"
                        >
                        </aims-lookup>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                  <!--Create-->
                  <aims-common-table-dynamic-row id="create">
                    <ng-template viewMode let-element>
                      <div class="text-center">
                        <ng-container *ngIf="element.create">
                          <img src="{{imgSrc}}/check.png" style="width:20px" />
                        </ng-container>
                        <ng-container *ngIf="!element.create">
                          <img src="{{imgSrc}}/X.png" style="width:20px" />
                        </ng-container>
                      </div>
                    </ng-template>
                    <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                      <div class="fullWidth text-center">
                        <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                      </div>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                  <!-- Read -->
                  <aims-common-table-dynamic-row id="read">
                    <ng-template viewMode let-element>
                      <div class="fullWidth text-center">
                        <ng-container *ngIf="element.read">
                          <img src="{{imgSrc}}/check.png" style="width:20px" />
                        </ng-container>
                        <ng-container *ngIf="!element.read">
                          <img src="{{imgSrc}}/X.png" style="width:20px" />
                        </ng-container>
                      </div>
                    </ng-template>
                    <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                      <div class="fullWidth text-center">
                        <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                      </div>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <!-- Update -->
                  <aims-common-table-dynamic-row id="update">
                    <ng-template viewMode let-element>
                      <div class="fullWidth text-center">
                        <ng-container *ngIf="element.update">
                          <img src="{{imgSrc}}/check.png" style="width:20px" />
                        </ng-container>
                        <ng-container *ngIf="!element.update">
                          <img src="{{imgSrc}}/X.png" style="width:20px" />
                        </ng-container>
                      </div>
                    </ng-template>
                    <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                      <div class="fullWidth text-center">
                        <mat-checkbox [formControl]="dynamicControl"></mat-checkbox>
                      </div>
                    </ng-template>
                  </aims-common-table-dynamic-row>

                  <!-- Delete -->
                  <aims-common-table-dynamic-row id="delete">
                    <ng-template viewMode let-element>
                      <div class="fullWidth text-center">
                        <ng-container *ngIf="element.delete">
                          <img src="{{imgSrc}}/check.png" style="width:20px" />
                        </ng-container>
                        <ng-container *ngIf="!element.delete">
                          <img src="{{imgSrc}}/X.png" style="width:20px" />
                        </ng-container>
                      </div>
                    </ng-template>
                    <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                      <div class="fullWidth text-center">
                        <mat-checkbox [formControl]="dynamicControl" ></mat-checkbox>
                      </div>
                    </ng-template>
                  </aims-common-table-dynamic-row>
              </aims-common-table>
            </div>
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab label="Groups">
      <div class="table-container">
        <!-- Groups -->
          <form novalidate #permGrid="ngForm" *ngIf="(sourceUserGroupMembership |async)!= null && this.isCloneUser.value == false">
            <div>
              <aims-common-table
                [dataSource]="sourceUserGroupsDataSource"
                [header]="userGroupsColumns"
                [permissions]="permissions"
                id="UserPermissionGroups"
                (rowAdded)="handleGroupsRowAdd($event)"
                (rowUpdated)="handleGroupsRowUpdate($event)"
                (rowDeleted)="handleGroupsRowDelete($event)"
                (rowCancelled)="handleGroupsRowCancelled($event)"
                [addRowInitialObject]="defaultGroupsAddRowInitialObject"
                [stickyHeader]="true"
                [pageSize]="10"
                [formOptions]="{ type: 'full' }"
              >
                <!-- Group Name -->
                <aims-common-table-dynamic-row id="permissionGroupId">
                  <ng-template viewMode let-element>
                    {{ element.permissionGroupId | getText:'permissionGroupId':'permissionGroupName':groupValues }}
                  </ng-template>
                  <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                    <aims-lookup
                      [ngClass]="{'ng-invalid': dynamicControl.invalid}"
                      name="permissionGroupId"
                      [gridText]="'Select a Group'"
                      id="groupNameLookup"
                      [values]="groupValues"
                      [idPropertyName]="'permissionGroupId'"
                      [displayPropertyName]="'permissionGroupName'"
                      [columnsInGrid]="groupNameLookupColumns"
                      [altDisplay]="dynamicControl?.value | getText:'permissionGroupId':'permissionGroupName':groupValues "
                      (valueChangeObj)="handleGroupsAimsLookupChange($event, element, dynamicControl)"
                    >
                    </aims-lookup>
                  </ng-template>
                </aims-common-table-dynamic-row>

                <aims-common-table-dynamic-row id="description">
                  <ng-template viewMode let-element>
                    {{ element.permissionGroup?.description }}
                  </ng-template>
                </aims-common-table-dynamic-row>

              </aims-common-table>
            </div>
          </form>

        <ng-container *ngIf="this.isCloneUser.value == true">
        <!-- Clone Groups -->
        <div class="flex-container">
          <!--Source User-->
          <div class="flex-column">
            <h4>Source User {{(this.sourceUser | async)?.userName}}</h4>
            <form novalidate #permGrid="ngForm" *ngIf="(sourceUserGroupMembership |async) != null">
              <div>
                <aims-common-table
                  [dataSource]="sourceUserGroupsDataSource"
                  [header]="cloneUserGroupsColumns"
                  [permissions]="clonePermissions"
                  id="CloneDestinationUserPermissionGroups"
                  (selectionClick)="handleCloneUserGroupRowClick($event)"
                  (selectionAllClick)="handleCloneUserGroupRowClick($event)"
                  [stickyHeader]="true"
                  [pageSize]="10"
                  [formOptions]="{ type: 'full' }"
                >
                  <!-- Group Name -->
                  <aims-common-table-dynamic-row id="permissionGroupId">
                    <ng-template viewMode let-element>
                      {{ element.permissionGroupId | getText:'permissionGroupId':'permissionGroupName':groupValues }}
                    </ng-template>
                    <ng-template editMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                      <aims-lookup
                        [ngClass]="{'ng-invalid': dynamicControl.invalid}"
                        name="permissionGroupId"
                        [gridText]="'Select a Group'"
                        id="groupNameLookup"
                        [values]="groupValues"
                        [idPropertyName]="'permissionGroupId'"
                        [displayPropertyName]="'permissionGroupName'"
                        [columnsInGrid]="groupNameLookupColumns"
                        [altDisplay]="dynamicControl?.value | getText:'permissionGroupId':'permissionGroupName':groupValues "
                        (valueChangeObj)="handleGroupsAimsLookupChange($event, element, dynamicControl)"
                      >
                      </aims-lookup>
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>
              </div>
            </form>
          </div>
          <!--Destination User-->
          <div class="flex-column">
            <h4>Destination User {{(this.destinationUser | async)?.userName}}</h4>
            <form novalidate #permGrid="ngForm" *ngIf="(destinationUserGroupMembership |async) != null">
              <div>
                <aims-common-table
                  [dataSource]="destinationUserGroupsDataSource"
                  [header]="cloneUserGroupsColumns"
                  [permissions]="clonePermissions"
                  id="CloneDestinationUserPermissionGroups"
                  [stickyHeader]="true"
                  [pageSize]="10"
                  [formOptions]="{ type: 'full' }"
                >
                  <!-- Group Name -->
                  <aims-common-table-dynamic-row id="permissionGroupId">
                    <ng-template viewMode let-element>
                      {{ element.permissionGroupId | getText:'permissionGroupId':'permissionGroupName':groupValues }}
                    </ng-template>
                  </aims-common-table-dynamic-row>
                </aims-common-table>
              </div>
            </form>
          </div>
        </div>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
